import { useState, useEffect } from 'react';

/**
 * Returns true if Box features (Box UOM, Box Price, Pieces Per Box) are enabled.
 * Defaults to true if no setting has been explicitly saved.
 */
export const isBoxEnabled = () => {
    try {
        const cached = localStorage.getItem('enable_box_uom');
        return cached === 'true';
    } catch (e) {
        return false;
    }
};

/**
 * Hook providing reactive access to the Box UOM enabled state.
 * Listens for local updates and cross-tab storage changes.
 */
export const useBoxSetting = () => {
    const [enableBox, setEnableBox] = useState(isBoxEnabled());

    useEffect(() => {
        const handleStorageChange = () => {
            setEnableBox(isBoxEnabled());
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('box_setting_changed', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('box_setting_changed', handleStorageChange);
        };
    }, []);

    const updateBoxSetting = (enabled) => {
        const strVal = enabled ? 'true' : 'false';
        localStorage.setItem('enable_box_uom', strVal);
        setEnableBox(enabled);
        window.dispatchEvent(new Event('box_setting_changed'));
        window.dispatchEvent(new Event('storage'));
    };

    return { enableBox, updateBoxSetting };
};

export default useBoxSetting;
